import {TOGGLE} from '@drivesally/sally-fw/lib/inputTypes';

import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

export default attribute({
  type: TOGGLE,
  attribute: 'default',
  label: {
    default: 'Default',
    short: 'Default',
  },
});
